<template>
  <div class="content-wrapper">
    <el-row :gutter="20">
      <el-col :span="4">
        <UserMenu />
      </el-col>
      <el-col :span="20" :loading="loading">
        <div class="content-title">信息维护</div>
        <el-card shadow="never">
          <el-form ref="clientForm" :model="clientForm" :rules="clientRules" label-width="120px" class="form-profile">
            <el-form-item label="客户类型" prop="clientType">
              {{ clientForm.clientTypeName }}
            </el-form-item>
            <el-form-item label="注册账号" prop="loginAccount">
              {{ displayAccount(clientForm.loginAccount) }}
            </el-form-item>
            <el-form-item label="商户名称" prop="clientName">
              {{ clientForm.clientName }}
            </el-form-item>
            <el-form-item label="邮箱" prop="clientMail">
              <el-input v-model="clientForm.clientMail" class="long-item" placeholder="请输入邮箱"/>
            </el-form-item>
            <el-form-item label="联系电话" prop="clientPhone">
              <el-input v-model="clientForm.clientPhone" class="long-item" placeholder="请输入联系电话"/>
            </el-form-item>
            <el-form-item label="邮编" prop="zipCode">
              <el-input v-model="clientForm.zipCode" class="long-item" placeholder="请输入邮编"/>
            </el-form-item>
            <el-form-item label="地区" prop="areaData">
              <AreaSelector v-model="clientForm.areaData" />
            </el-form-item>
            <el-form-item label="联系地址" prop="detailAddress">
              <el-input v-model="clientForm.detailAddress" class="long-item" placeholder="请输入联系地址"/>
            </el-form-item>
            <!-- <el-form-item v-if="clientForm.clientType === '01' && clientForm.clientBu" label="所属部门" prop="clientBu">
              {{ clientForm.clientBu }}
            </el-form-item>
            <el-form-item v-if="clientForm.clientType === '01' && clientForm.clientRegion" label="所属销售区域" prop="clientRegion">
              {{ clientForm.clientRegion }}
            </el-form-item> -->
            <el-form-item v-if="clientForm.clientType === '01' && clientForm.clientCategoryName" label="客户分类" prop="clientCategoryName">
              {{ clientForm.clientCategoryName }}
            </el-form-item>
            <el-form-item v-if="clientForm.clientType === '01' && clientForm.paymentCode" label="支付代码" prop="paymentCode">
              {{ clientForm.paymentCode }}
            </el-form-item>
            <el-form-item v-if="clientForm.clientType === '01' && clientForm.licenceImageUri" label="营业执照图片" prop="licenceImageId">
              <img :src="getImage(clientForm.licenceImageUri)" class="img" @click="handleFilePreview(clientForm.licenceImageUri)">
            </el-form-item>
            <el-form-item v-if="clientForm.clientType === '01' && clientForm.cardImageUri" label="名片图片" prop="cardImageId">
              <img :src="getImage(clientForm.cardImageUri)" class="img" @click="handleFilePreview(clientForm.cardImageUri)">
            </el-form-item>
            <el-form-item>
              <el-button :loading="formLoading" type="primary" class="btn-red" @click="saveProfile">保 存</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import formValidators from '@/utils/formValidators'
import { commonUtils } from '@/utils/common'
import userApi from '@/api/user'
import UserMenu from './components/user-menu'
import AreaSelector from '@/components/area-selector'
export default {
  name: 'UserProfile',
  components: {
    UserMenu,
    AreaSelector
  },
  data() {
    return {
      clientForm: {},
      clientRules: {
        clientName: [
          { required: true, message: '请输入商户名称', trigger: 'change' }
        ],
        areaData: [
          { required: true, message: '请设置地区信息', trigger: 'change' },
          { validator: formValidators.validateAreaData, trigger: 'change' }
        ]
      },
      loading: false,
      formLoading: false
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  mounted() {
    this.getCurrentClientInfo()
  },
  methods: {
    getCurrentClientInfo() {
      this.loading = true
      userApi.queryProfile().then(response => {
        this.loading = false
        const clientInfo = response.data.resultData.clientInfo
        clientInfo.areaData = {
          provinceId: clientInfo.provinceId || '',
          cityId: clientInfo.cityId || '',
          countyId: clientInfo.countyId || ''
        }
        this.clientForm = clientInfo
        this.$nextTick(() => {
          this.$refs['clientForm'].clearValidate()
        })
      }).catch(() => {
        this.loading = false
      })
    },
    displayAccount(loginAccount) {
      return commonUtils.maskMobileNo(loginAccount)
    },
    saveProfile() {
      this.$refs['clientForm'].validate((valid) => {
        if (valid) {
          this.formLoading = true
          this.clientForm.provinceId = this.clientForm.areaData.provinceId
          this.clientForm.cityId = this.clientForm.areaData.cityId
          this.clientForm.countyId = this.clientForm.areaData.countyId
          userApi.updateProfile(this.clientForm).then(response => {
            this.formLoading = false
            if (response.data.resultCode === '0') {
              const newUserInfo = this.userInfo
              newUserInfo.clientName = this.clientForm.clientName
              this.$store.commit('UPDATE_USER_INFO', newUserInfo)
              this.$alert('用户信息已更新','系统提示', {
                type: 'success'
              })
            }
          }).catch(() => {
            this.formLoading = false
          })
        }
      })
    },
    getImage(uri) {
      return commonUtils.getImageUrl(uri)
    },
    handleFilePreview(uri) {
      window.open(commonUtils.getImageUrl(uri))
    }
  }
}
</script>

<style lang="scss" scoped>
.form-profile {
  width: 600px;
  .long-item {
    width: 300px;
  }
}
.img {
  max-width: 100px;
  max-height: 100px;
}
</style>
